import { createFileRoute } from "@tanstack/react-router";
import { PortfolioAssetsPage } from "../../features/portfolio/pages/portfolio-assets-page";

export const Route = createFileRoute("/_layout/portfolio/assets")({
  component: PortfolioAssetsPage,
});
